import { BasicObject } from './checkout.interface';

export interface MobileRecoveryProductData {
    brand?: string;
    name: string;
    url?: string;
}

export interface MobileRecoveryProduct {
    bonus: number;
    dates: BasicObject;
    hasBonus: boolean;
    item: MobileRecoveryProductData;
}

export interface MobileRecoveryData {
    estimation?: MobileRecoveryEstimate;
    product: MobileRecoveryProductData;
    criterias: MobileRecoveryCriterias;
}

interface MobileRecoveryCriterias {
    id: string;
    imei: string;
}

interface MobileRecoveryEstimate {
    amount: number;
    id: string;
    shipping: MobileRecoveryShipping[];
    items: MobileRecoveryEstimateItems;
}

interface MobileRecoveryEstimateItems {
    id: string;
    criteresReprise: MobileRecoveryCritere[];
}

export interface MobileRecoveryCritere {
    id: string;
    question: string;
    reponse: MobileRecoveryCritereResponse;
}

interface MobileRecoveryCritereResponse {
    id: string;
    value: string;
}

export interface MobileRecoveryShipping {
    insurance: boolean;
    modeLivraison: string;
    montantAssurance: number;
    montantLivraison: number;
}

export enum MobileRecoveryStatus {
    COMPLETED = 'completed',
    ONGOING = 'ongoing',
    UNFINISHED = 'unfinished',
    UNSTARTED = 'unstarted',
}

export enum MobileRecoverySteps {
    START = 'start',
    HOMEPAGE = 'homepage',
    ESTIMATION = 'estimation',
    PAYMENT = 'payment',
}
